// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { IncidentAnalysisAreaId } from './IncidentAnalysisAreaId'
import {
  IncidentAnalysisAreaNavigation,
  IncidentAnalysisAreaNavigationIcon,
} from './IncidentAnalysisAreaNavigation'
import { IncidentAnalysisAreaRoutes } from './IncidentAnalysisAreaRoutes'

const LazyIncidentAnalysisComponent = lazy(
  () => import('./IncidentAnalysisArea'),
)

const IncidentAnalysisComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyIncidentAnalysisComponent />
  </SuspenseLoadingWrapper>
)

export const IncidentAnalysisArea = {
  id: IncidentAnalysisAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_INCIDENT_ANALYSIS,
  Icon: IncidentAnalysisAreaNavigationIcon,
  NavigationComponent: IncidentAnalysisAreaNavigation,
  route: {
    path: IncidentAnalysisAreaRoutes.route,
    component: IncidentAnalysisComponent,
  },
}
